<!--隐私协议-->
<template>
    <div class="reload-view">
        <div class="main">
            <div class="main-cat-option">
                <van-cell-group inset class="main-input">
                    <van-field
                        class="main-input"
                        v-model="reason"
                        rows="4"
                        type="textarea"
                        maxlength="100"
                        placeholder="请输入您需要申请选项的详细原因。审核完成后，可开通此选项。"
                        show-word-limit
                    />
                </van-cell-group>
            </div>


            <div class="main-icon-tips">
                咨询客服电话:0516-83000520
            </div>

            <div class="btn-container" @click="setAccount">
                发送申请审核
            </div>
        </div>
        <ReferralFooter index="1"/>

    </div>
    <div class="footer">
        <p>江苏爱驿站信息科技有限公司</p>
        <p>Copyright © 2014-2025 Aiyizhan All Rights Reserved</p>
    </div>
</template>

<script>
import ReferralFooter  from "@/components/referralFooter.vue";
import ayzAjax from "@/plugins/axios";
import {showFailToast, showSuccessToast} from "vant";

export default {
    name: "ReloadView",
    components: {
        ReferralFooter
    },
    data: function () {
        return {
            reason:'',
            params:null,
            jwtInfo:null,
            userInfo:null,
        }
    },
    created() {
        this.params = this.$route.query;
        this.jwtInfo = JSON.parse(localStorage.getItem('jwtInfo'));
        if (this.jwtInfo === null){
            this.$router.push({ path: '/referral/index'});
        }
    },
    methods: {

        setAccount(){
            // let fromData = {};
            // fromData.receive_account = this.account;
            this.params.apply_reason = this.reason;
            this.params.apply_type = 1;
            this.params.apply_value = 3;
            // console.log(this.params);
            ayzAjax.post('/referral/change_attribute_apply',this.params,{
                headers: {
                    'Authorization': 'Bearer ' + this.jwtInfo.access_token,
                }
            }).then((response) => {
                if(response.data.code !== 200){
                    
                    return showFailToast(response.data.msg)
                }
                showSuccessToast('操作成功,请耐心等待')
                setTimeout(()=>{
                    this.$router.push({ path: '/referral/index'});
                },1000)
                
            })
        },


    }
}
</script>

<style lang="scss" scoped>

.reload-view{
    background-color: #FFFFFF;
    text-align: left;
    .main{
        height: 600px;
        background: #FFFFFF;
        text-align: center;
        .main-cat-option{
            padding-top: 25px;
            height: 50px;
            border-radius: 10px 10px 10px 10px;
        }
        .main-icon-tips{
            margin-top: 130px;
            text-align: center;
            font-size: 12px;
            color: #222222;
        }
        .btn-container{
            margin: 20px auto;
            width: 300px;
            text-align: center;
            line-height: 50px;
            height: 50px;
            background: #FE405F;
            border-radius: 10px 10px 10px 10px;
            font-weight: 500;
            font-size: 13px;
            color: #FFFFFF;
        }
    }
}
.main-input{
    background: #F9F9F9;
}
.footer{
    margin-top: -80px;
    text-align: center;
    color: #A5A5A5;
    font-weight: 300;
    font-size: 13px;
}
</style>
